import { CSS } from '@stitches/react'

export const chartCSS: CSS = {
  height: '300px',
  width: '100%',
} as const

export const pieSize = 100

export const pieCSS: CSS = {
  height: '300px',
  width: '100%',
  maxWidth: '450px',
} as const

export const componentCss: CSS = {
  display: 'flex',
  '> div': { flex: '1 1 50%' },
  '> section': { flex: '1 1 25%', justifyContent: 'center' },
} as const
